module.exports = __webpack_public_path__ + "img/fr.4163a98e.svg";